export default {
  FUNDING_FAIL_HEADER: "Your funds purchase failed.",
  FUNDING_FAIL_SUBHEADINGS: [
    "We've had a problem transerring your funds or buying your assets.",
    "Please check your account balance and try again, or reach out to us at support@brightmoney.co for assistance.",
  ],
  FUNDING_FAIL_BUTTON_HEADING: "Check Status",
};
